import axios from 'axios';

const PREFIJO = '/api/Npqt/';

export default {
  paquetesVersionComercial(formulario) {
    const dto = {
      ndt1: formulario.version.id,//version comercial
      ndt2: formulario.potencia.motor.id,//motor
      ndt3: formulario.potencia.transmision.id,//transmision
      ndt4: formulario.potencia.traccion.id,//traccion
      ndt5: formulario.version.ndt10,//año paquete
    };
    return axios.post(`${PREFIJO}VmSlCbm`, dto);
  },
  resumenPaquete(data) {
    const dto = {
      ndt1: data.paquete.id//id de paquete
    };
    return axios.post(`${PREFIJO}VmSlVlr`, dto);
  },
  comparacionPaquete(data) {
    const dto = {ndt1: data.ndt11};
    return axios.post(`${PREFIJO}VmSlPqt`, dto);
  }
};
